import Ellipses from '@common/EllipsesPresets/EllipsesPresets';
import React from 'react';
import styled from 'styled-components';

const DelegateItem = (props) => {
	const {user} = props;
	return (
		<StyledSection {...props}>
			<section className="delegate-name">
				<Ellipses.Single>{`${user.firstName} ${user.lastName}`}</Ellipses.Single>
			</section>
			<section className="delegate-email">{user.emailAddress}</section>
		</StyledSection>
	);
};

export default DelegateItem;

const StyledSection = styled.section`
	display: flex;
	flex-flow: column;
	width: calc(100% - var(--px-30));
	padding: 0 0 var(--px-8) 0;
	gap: var(--px-3);
	.delegate-name {
		font-weight: 400;
		font-size: var(--px-14);
		line-height: var(--px-20);
		color: var(--neutrals-900);
	}
	.delegate-email {
		font-weight: 300;
		font-size: var(--px-12);
		line-height: var(--px-18);
		color: var(--neutrals-700);
	}
`;
